import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var INDRAIbeAdminMktService = /** @class */ (function () {
    function INDRAIbeAdminMktService(http) {
        this.http = http;
    }
    INDRAIbeAdminMktService.prototype.sendEmail = function (campaignId, emailTo, params) {
        return this.http
            .post(environment.api_url + "/ibe/admin/mkt/campaigns/" + campaignId + "/launchWithParams?destination=" + emailTo, params);
    };
    INDRAIbeAdminMktService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAIbeAdminMktService_Factory() { return new INDRAIbeAdminMktService(i0.inject(i1.HttpClient)); }, token: INDRAIbeAdminMktService, providedIn: "root" });
    return INDRAIbeAdminMktService;
}());
export { INDRAIbeAdminMktService };
